import * as React from 'react';
import { generatePath, Link } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/KeyboardArrowDown';

import { getUserProfileItems } from 'layouts/AppPageTemplate/utils/menus';
import { useRegion } from 'common/hooks/region';
import { usePermissions } from 'utils/permissions';
import { useUserContext } from 'common/contexts/UserContext';

interface Props {
  onMenuOpen: () => void;
}

export const SettingsMenu: React.FC<Props> = (props) => {
  const { onMenuOpen } = props;
  const { user } = useUserContext();
  const permissions = usePermissions();
  const items = React.useMemo(() => getUserProfileItems(permissions, user), [permissions, user]);
  const region = useRegion();

  return (
    <>
      {items.map((menu) => (
        <li key={menu.title}>
          <Accordion
            disableGutters
            elevation={0}
            defaultExpanded={false}
            sx={[
              () => ({
                '&:before': {
                  backgroundColor: 'white',
                },
                background: 'none',
              }),
            ]}
          >
            <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                margin: 0,
                padding: 0,
                minHeight: '0px',
                '& .MuiAccordionSummary-content': {
                  margin: '0px',
                },
              }}
            >
              <div className="w-full flex justify-between items-center py-1 px-4 rounded-md text-blue-300 font-semibold hover:bg-darkblue-900">
                <h1>{menu.title}</h1>
                <ExpandMoreIcon style={{ fontSize: '36px' }} />
              </div>
            </AccordionSummary>
            <AccordionDetails sx={{ margin: 0, padding: 0 }}>
              <ul className="flex flex-col space-y-2 mt-4">
                {menu.children.map((item) => (
                  <li key={item.page.title} className="pl-4" onClick={onMenuOpen}>
                    <Link
                      key={item.page.title}
                      to={generatePath(item.page.path, { region: region.route })}
                    >
                      <h2 className="py-1 px-4 rounded-md text-blue-300 font-semibold hover:bg-darkblue-900">
                        {item.page.title}
                      </h2>
                    </Link>
                  </li>
                ))}
              </ul>
            </AccordionDetails>
          </Accordion>
        </li>
      ))}
    </>
  );
};
